module.exports = __webpack_public_path__ + "img/icon-charge@2x.c13b3805.png";